export default "<p>\n  string-element-config works!\n</p>\n";